import axios from "axios";

const makePutRequest = async (route, data) => {
  const apiUrl = import.meta.env.VITE_API_URL;
  const apiRoute = route;
  const apiEndpoint = `${apiUrl}${apiRoute}`;

  try {
    const response = await axios.put(apiEndpoint, data, {
      withCredentials: true,
    });
    return { data: response.data, error: null };
  } catch (error) {
    const backendErrorMessage =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : "okänt fel"; // Fallback error message
    return { data: null, error: backendErrorMessage };
  }
};

export default makePutRequest;
